function ref(flag: string) {
  return `/assets/image/flag/${flag}`
}

/**
 * An index of flag icons.
 * Filenames are according to:
 * - *ISO 3166-1 alpha-2* — Country codes
 * - *ISO 3166-2:GB* — British subdivisions
 *
 * Official flag images are courtesy of David Krmela at Flagpedia.
 * These images are public domain.
 * https://flagpedia.net/download/icons
 */
export const FlagAssets = new Map<string, string>([
  // Error flag for when a flag is not found.
  ["404", ref("_404.png")],
  ["ad", ref("ad.png")],
  ["ae", ref("ae.png")],
  ["af", ref("af.png")],
  ["ag", ref("ag.png")],
  ["ai", ref("ai.png")],
  ["al", ref("al.png")],
  ["am", ref("am.png")],
  ["ao", ref("ao.png")],
  ["aq", ref("aq.png")],
  ["ar", ref("ar.png")],
  ["as", ref("as.png")],
  ["at", ref("at.png")],
  ["au", ref("au.png")],
  ["aw", ref("aw.png")],
  ["ax", ref("ax.png")],
  ["az", ref("az.png")],
  ["ba", ref("ba.png")],
  ["bb", ref("bb.png")],
  ["bd", ref("bd.png")],
  ["be", ref("be.png")],
  ["bf", ref("bf.png")],
  ["bg", ref("bg.png")],
  ["bh", ref("bh.png")],
  ["bi", ref("bi.png")],
  ["bj", ref("bj.png")],
  ["bl", ref("bl.png")],
  ["bm", ref("bm.png")],
  ["bn", ref("bn.png")],
  ["bo", ref("bo.png")],
  ["bq", ref("bq.png")],
  ["br", ref("br.png")],
  ["bs", ref("bs.png")],
  ["bt", ref("bt.png")],
  ["bv", ref("bv.png")],
  ["bw", ref("bw.png")],
  ["by", ref("by.png")],
  ["bz", ref("bz.png")],
  ["ca", ref("ca.png")],
  ["cc", ref("cc.png")],
  ["cd", ref("cd.png")],
  ["cf", ref("cf.png")],
  ["cg", ref("cg.png")],
  ["ch", ref("ch.png")],
  ["ci", ref("ci.png")],
  ["ck", ref("ck.png")],
  ["cl", ref("cl.png")],
  ["cm", ref("cm.png")],
  ["cn", ref("cn.png")],
  ["co", ref("co.png")],
  ["cr", ref("cr.png")],
  ["cu", ref("cu.png")],
  ["cv", ref("cv.png")],
  ["cw", ref("cw.png")],
  ["cx", ref("cx.png")],
  ["cy", ref("cy.png")],
  ["cz", ref("cz.png")],
  ["de", ref("de.png")],
  ["dj", ref("dj.png")],
  ["dk", ref("dk.png")],
  ["dm", ref("dm.png")],
  ["do", ref("do.png")],
  ["dz", ref("dz.png")],
  ["ec", ref("ec.png")],
  ["ee", ref("ee.png")],
  ["eg", ref("eg.png")],
  ["eh", ref("eh.png")],
  ["er", ref("er.png")],
  ["es", ref("es.png")],
  ["et", ref("et.png")],
  ["fi", ref("fi.png")],
  ["fj", ref("fj.png")],
  ["fk", ref("fk.png")],
  ["fm", ref("fm.png")],
  ["fo", ref("fo.png")],
  ["fr", ref("fr.png")],
  ["ga", ref("ga.png")],
  ["gb-eng", ref("gb-eng.png")],
  ["gb-nir", ref("gb-nir.png")],
  ["gb-sct", ref("gb-sct.png")],
  ["gb-wls", ref("gb-wls.png")],
  ["gb", ref("gb.png")],
  ["gd", ref("gd.png")],
  ["ge", ref("ge.png")],
  ["gf", ref("gf.png")],
  ["gg", ref("gg.png")],
  ["gh", ref("gh.png")],
  ["gi", ref("gi.png")],
  ["gl", ref("gl.png")],
  ["gm", ref("gm.png")],
  ["gn", ref("gn.png")],
  ["gp", ref("gp.png")],
  ["gq", ref("gq.png")],
  ["gr", ref("gr.png")],
  ["gs", ref("gs.png")],
  ["gt", ref("gt.png")],
  ["gu", ref("gu.png")],
  ["gw", ref("gw.png")],
  ["gy", ref("gy.png")],
  ["hk", ref("hk.png")],
  ["hm", ref("hm.png")],
  ["hn", ref("hn.png")],
  ["hr", ref("hr.png")],
  ["ht", ref("ht.png")],
  ["hu", ref("hu.png")],
  ["id", ref("id.png")],
  ["ie", ref("ie.png")],
  ["il", ref("il.png")],
  ["im", ref("im.png")],
  ["in", ref("in.png")],
  ["io", ref("io.png")],
  ["iq", ref("iq.png")],
  ["ir", ref("ir.png")],
  ["is", ref("is.png")],
  ["it", ref("it.png")],
  ["je", ref("je.png")],
  ["jm", ref("jm.png")],
  ["jo", ref("jo.png")],
  ["jp", ref("jp.png")],
  ["ke", ref("ke.png")],
  ["kg", ref("kg.png")],
  ["kh", ref("kh.png")],
  ["ki", ref("ki.png")],
  ["km", ref("km.png")],
  ["kn", ref("kn.png")],
  ["kp", ref("kp.png")],
  ["kr", ref("kr.png")],
  ["kw", ref("kw.png")],
  ["ky", ref("ky.png")],
  ["kz", ref("kz.png")],
  ["la", ref("la.png")],
  ["lb", ref("lb.png")],
  ["lc", ref("lc.png")],
  ["li", ref("li.png")],
  ["lk", ref("lk.png")],
  ["lr", ref("lr.png")],
  ["ls", ref("ls.png")],
  ["lt", ref("lt.png")],
  ["lu", ref("lu.png")],
  ["lv", ref("lv.png")],
  ["ly", ref("ly.png")],
  ["ma", ref("ma.png")],
  ["mc", ref("mc.png")],
  ["md", ref("md.png")],
  ["me", ref("me.png")],
  ["mf", ref("mf.png")],
  ["mg", ref("mg.png")],
  ["mh", ref("mh.png")],
  ["mk", ref("mk.png")],
  ["ml", ref("ml.png")],
  ["mm", ref("mm.png")],
  ["mn", ref("mn.png")],
  ["mo", ref("mo.png")],
  ["mp", ref("mp.png")],
  ["mq", ref("mq.png")],
  ["mr", ref("mr.png")],
  ["ms", ref("ms.png")],
  ["mt", ref("mt.png")],
  ["mu", ref("mu.png")],
  ["mv", ref("mv.png")],
  ["mw", ref("mw.png")],
  ["mx", ref("mx.png")],
  ["my", ref("my.png")],
  ["mz", ref("mz.png")],
  ["na", ref("na.png")],
  ["nc", ref("nc.png")],
  ["ne", ref("ne.png")],
  ["nf", ref("nf.png")],
  ["ng", ref("ng.png")],
  ["ni", ref("ni.png")],
  ["nl", ref("nl.png")],
  ["no", ref("no.png")],
  ["np", ref("np.png")],
  ["nr", ref("nr.png")],
  ["nu", ref("nu.png")],
  ["nz", ref("nz.png")],
  ["om", ref("om.png")],
  ["pa", ref("pa.png")],
  ["pe", ref("pe.png")],
  ["pf", ref("pf.png")],
  ["pg", ref("pg.png")],
  ["ph", ref("ph.png")],
  ["pk", ref("pk.png")],
  ["pl", ref("pl.png")],
  ["pm", ref("pm.png")],
  ["pn", ref("pn.png")],
  ["pr", ref("pr.png")],
  ["ps", ref("ps.png")],
  ["pt", ref("pt.png")],
  ["pw", ref("pw.png")],
  ["py", ref("py.png")],
  ["qa", ref("qa.png")],
  ["re", ref("re.png")],
  ["ro", ref("ro.png")],
  ["rs", ref("rs.png")],
  ["ru", ref("ru.png")],
  ["rw", ref("rw.png")],
  ["sa", ref("sa.png")],
  ["sb", ref("sb.png")],
  ["sc", ref("sc.png")],
  ["sd", ref("sd.png")],
  ["se", ref("se.png")],
  ["sg", ref("sg.png")],
  ["sh", ref("sh.png")],
  ["si", ref("si.png")],
  ["sj", ref("sj.png")],
  ["sk", ref("sk.png")],
  ["sl", ref("sl.png")],
  ["sm", ref("sm.png")],
  ["sn", ref("sn.png")],
  ["so", ref("so.png")],
  ["sr", ref("sr.png")],
  ["ss", ref("ss.png")],
  ["st", ref("st.png")],
  ["sv", ref("sv.png")],
  ["sx", ref("sx.png")],
  ["sy", ref("sy.png")],
  ["sz", ref("sz.png")],
  ["tc", ref("tc.png")],
  ["td", ref("td.png")],
  ["tf", ref("tf.png")],
  ["tg", ref("tg.png")],
  ["th", ref("th.png")],
  ["tj", ref("tj.png")],
  ["tk", ref("tk.png")],
  ["tl", ref("tl.png")],
  ["tm", ref("tm.png")],
  ["tn", ref("tn.png")],
  ["to", ref("to.png")],
  ["tr", ref("tr.png")],
  ["tt", ref("tt.png")],
  ["tv", ref("tv.png")],
  ["tw", ref("tw.png")],
  ["tz", ref("tz.png")],
  ["ua", ref("ua.png")],
  ["ug", ref("ug.png")],
  ["um", ref("um.png")],
  ["us", ref("us.png")],
  ["uy", ref("uy.png")],
  ["uz", ref("uz.png")],
  ["va", ref("va.png")],
  ["vc", ref("vc.png")],
  ["ve", ref("ve.png")],
  ["vg", ref("vg.png")],
  ["vi", ref("vi.png")],
  ["vn", ref("vn.png")],
  ["vu", ref("vu.png")],
  ["wf", ref("wf.png")],
  ["ws", ref("ws.png")],
  ["xk", ref("xk.png")],
  ["ye", ref("ye.png")],
  ["yt", ref("yt.png")],
  ["za", ref("za.png")],
  ["zm", ref("zm.png")],
  ["zw", ref("zw.png")],
] as const);
